import { render } from "./BusinessPartners.vue?vue&type=template&id=45a8b5b3&scoped=true"
import script from "./BusinessPartners.vue?vue&type=script&lang=js"
export * from "./BusinessPartners.vue?vue&type=script&lang=js"

import "./BusinessPartners.vue?vue&type=style&index=0&id=45a8b5b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a8b5b3"]])

export default __exports__